import { ArrowLeftIcon } from '@heroicons/react/24/outline';

import IconButton from '../../components/IconButton';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

/**
 * L'en-tête de la fiche : le retour à la liste et le nom de la chambre — même
 * forme que l'en-tête du fil de conversation. Le panneau reste à un retour.
 */
interface EnteteFicheProps {
    titre: string;
    sousTitre?: string;
    onRetour: () => void;
    /** Nom accessible du retour. « Mes chambres » par défaut ; la maintenance le surcharge. */
    libelleRetour?: string;
}

export default function EnteteFiche({
    titre,
    sousTitre,
    onRetour,
    libelleRetour = t('menage.retourMesChambres'),
}: EnteteFicheProps) {
    return (
        <header className="flex items-center gap-2 border-b border-border-color-light bg-white px-3 py-2">
            <IconButton libelle={libelleRetour} onPress={onRetour}>
                <ArrowLeftIcon className="h-6 w-6 text-text-color" />
            </IconButton>
            <div className="min-w-0 flex-1">
                <Text variante="sousTitre" as="h1" className="truncate">
                    {titre}
                </Text>
                {sousTitre && (
                    <Text variante="petit" ton="attenue" className="truncate">
                        {sousTitre}
                    </Text>
                )}
            </div>
        </header>
    );
}
